import { MARCA_SUPORTE_LOAD, MARCA_SUPORTE_UNLOAD } from "../../actions/Constants";

const INITIAL_STATE = { all: [] };

export default function marcaModelo(state = INITIAL_STATE, action) {
  switch (action.type) {
    case MARCA_SUPORTE_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload : null,
      };
    case MARCA_SUPORTE_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
